import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as profileActions from '../../actions';
import * as UI from '../../elements/ui';
import Ionicon from 'react-ionicons';
import * as helpers from '../../helpers/generalHelpers';

const ProfileHOC = (WrappedComponent, WrappedForm, isProfileList) => {
	class _ProfileHOC extends Component {
		constructor(props) {
			super(props);
			this.state = {
				isThisFormOpen: false,
				stayOpen: false,
				formId: null,
				error: false,
				postError: false,
			};
		}

		componentWillMount() {
			this.setState({ formId: helpers.randomNum() });
		}

		componentWillReceiveProps(nextProps) {
			if (nextProps.formOpenId === null) this.setState({ error: false });
			this.props.componentData.person_id &&
			this.props.formOpenId !== nextProps.formOpenId
				? this.props.getProfileComplete(this.props.componentData.person_id)
				: null;
		}

		handleEditing = toggle => {
			const { setFormVisibility, isOtherFormOpen } = this.props,
				{ formId } = this.state;

			if (toggle) {
				if (isOtherFormOpen) return this.setState({ error: true });
				else {
					this.setState({ isThisFormOpen: true });
					return setFormVisibility(toggle, formId);
				}
			} else {
				this.setState({ isThisFormOpen: false });
				return setFormVisibility(toggle, null);
			}
		};

		callBackFromApi = error => {
			if (error) return this.setState({ postError: error.status });
			const { setFormVisibility } = this.props,
				{ stayOpen } = this.state;
			this.setState({ isThisFormOpen: false });
			setFormVisibility(false, null);
			return stayOpen ? null : this.handleEditing(false);
		};

		handleData = formData => {
			const { componentAction, componentData } = this.props,
				personId = componentData.personId || componentData.person_id,
				payload = formData ? formData : null,
				type = formData && formData.type ? formData.type : 'DELETE';
			return componentAction(personId, payload, type, this.callBackFromApi);
		};

		render() {
			const { props, state, handleEditing, handleData } = this,
				{
					componentData,
					styles,
					summaryToggle,
					formOpenId,
					isOtherFormOpen,
					guestMode,
				} = props,
				{ formId, error, isThisFormOpen, postError } = state,
				{ noData } = componentData,
				buttonHandlers = { handleEditing, handleData },
				usePencilIcon = componentData.body && summaryToggle;
			if (noData && guestMode) return null;

			const profileList = isProfileList ? 'profile-list' : '';
			return (
				<section id={styles && styles.id} className={styles && styles.section}>
					<div className={styles && 'container'}>
						<div className={styles && 'row'}>
							<div className={`col-12 ${profileList}`}>
								<div className="profile-section-header-box">
									{styles && (
										<h2 className={`h2 ${styles && styles.header.style} `}>
											{styles && styles.header.content}
										</h2>
									)}
									<UI.OpenFormError
										error={error}
										isGuestMode={guestMode ? guestMode : false}
									/>
									<UI.PostErrorMessage
										error={postError}
										onClose={() => this.setState({ postError: false })}
									/>
									{/*show when not in guestMode*/}
									{!guestMode && (
										<div>
											{styles && (
												<button
													type="button"
													data-position="right"
													className={`btn btn-add btn-circle header-btn`}
													onClick={() =>
														buttonHandlers.handleEditing(!isThisFormOpen)
													}
												>
													<span className="icon">
														<Ionicon
															icon={
																isThisFormOpen
																	? 'ion-android-close'
																	: usePencilIcon
																	? 'ion-edit'
																	: 'ion-android-add'
															}
														/>
													</span>
												</button>
											)}
										</div>
									)}
									{/*/////////*/}
								</div>
								{isOtherFormOpen && formOpenId === formId ? (
									<WrappedForm
										{...componentData}
										buttonHandlers={buttonHandlers}
									/>
								) : (
									<WrappedComponent
										{...componentData}
										childrenData={componentData}
										buttonHandlers={buttonHandlers}
										guestMode={guestMode}
									/>
								)}
							</div>
						</div>
					</div>
				</section>
			);
		}
	}

	const mapStateToProps = state => {
		return {
			ui: state.profile.ui,
			formOpenId: state.profile.forms.Id,
			isOtherFormOpen: state.profile.forms.editing,
		};
	};

	const mapDispatchToProps = (dispatch, props) => {
		return {
			componentAction: (personId, payload, type, callback) =>
				dispatch(
					profileActions[props.actionName](personId, payload, type, callback)
				),
			setFormVisibility: (toggle, formId) =>
				dispatch(profileActions.showForm(toggle, formId)),
			getProfile: (personId, guestMode) =>
				dispatch(profileActions.getProfile(personId, guestMode)),
			getProfileComplete: personId =>
				dispatch(profileActions.getProfileComplete(personId)),
		};
	};

	_ProfileHOC.propTypes = {
		componentData: PropTypes.object.isRequired,
		actionName: PropTypes.string.isRequired,
	};

	return connect(
		mapStateToProps,
		mapDispatchToProps
	)(_ProfileHOC);
};

export default ProfileHOC;



// WEBPACK FOOTER //
// src/client/components/site/features/profile/components/HOC/ProfileHOC.js